import SelectorSystem from './SelectorSystem';
import './SelectorSystem.scss';

export default SelectorSystem;
